/*
 * Reducer actions related with login
 */
import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from './snackbarAction';
import { onLoginProfileData, dashboardApi } from './dashboardAction';
import firebase from 'firebase/app';

async function onSignAnalytics(user) {
  await firebase.analytics().logEvent('login', {
    EnrolmentNo: user[0].EnrolmentNo,
    EmailiD: user[0].EmailiD,
    date_login: new Date(),
    BatchName: user[0].BatchName
  });
  firebase
    .analytics()
    .setUserId(
      get(user, 'EmpCode', get(user[0], 'EnrolmentNo', 'Not Available'))
    );
  firebase.analytics().setUserProperties({
    Name: get(user, 'FullName', get(user[0], 'FirstName', 'Not Available')),
    'Email ID': get(user, 'EmailiD', get(user[0], 'EmailiD', 'Not Available'))
  });
}

export function forgetPasswordSwipe(response) {
  return {
    type: types.FORGETPASS_SWIPE,
    response
  };
}
export function setloginData(response) {
  return {
    type: types.LOGIN_DATA,
    response
  };
}

export function generatePasswordSwipe(response) {
  return {
    type: types.GENERATEPASS_SWIPE,
    response
  };
}
export function requestLogin(username, password) {
  return {
    type: types.LOGIN_REQUEST,
    username,
    password
  };
}

export function loginFailed() {
  return {
    type: types.LOGIN_FAILED
  };
}

export function onLoginResponse(response) {
  return {
    type: types.LOGIN_RESPONSE,
    response
  };
}

export function enableLoader() {
  return {
    type: types.LOGIN_ENABLE_LOADER
  };
}

export function disableLoader() {
  return {
    type: types.LOGIN_DISABLE_LOADER
  };
}

export function logOut() {
  return {
    type: types.LOG_OUT
  };
}

export function changeAcademicSessionData(response) {
  return {
    type: types.CHANGE_ACADEMIC_SESSION,
    response
  };
}
export function createPassword(response) {
  return {
    type: types.CREATE_PASSWORD,
    response
  };
}
export function forgetPassword(response) {
  return {
    type: types.FORGET_PASSWORD,
    response
  };
}
export function setApplicationNumber(response) {
  return {
    type: types.APPLICATION_NUMBER,
    response
  };
}

export const authenticateUser = async (
  uid,
  password,
  loginType,
  deviceToken,
  captchaResponse,
  studentId,
  dispatch
) => {
  dispatch(enableLoader());
  try {
    if (!uid || !password || !loginType || !deviceToken || !captchaResponse) {
      dispatch(
        openSnackBar({
          message: 'Please fill all the details.',
          severity: 'error'
        }),
        dispatch(disableLoader())
      );
      return Promise.reject();
    }
    let url;
    if (loginType === 'student' && !studentId) {
      url = 'oauth2/astoken';
    } else if (loginType === 'teacher' && !studentId) {
      url = 'oauth2/token';
    } else {
      url = 'oauth2/verifyotp';
    }
    let body = {
      UserName: uid,
      Password: password,
      Devicetoken: deviceToken,

      DeviceType: 'Web'
    };
    if (studentId) {
      body.StudentID = parseInt(studentId);
    }
    if (captchaResponse) {
      body = {
        ...body,
        'g-recaptcha-response': captchaResponse
      };
    }
    return await fetchPost(url, body)
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (data.error) {
          if (get(data, 'data.OTP', false)) {
            dispatch(
              openSnackBar({ message: data.message, severity: 'warning' })
            );
            dispatch(onLoginResponse(data));
            dispatch(disableLoader());
            return data;
          } else {
            dispatch(
              openSnackBar({
                message:
                  loginType === 'student'
                    ? 'Kindly enter Correct Application Form No and Password'
                    : 'Kindly enter correct Username and Password',
                severity: 'error'
              })
            );
            dispatch(disableLoader());
          }
          return console.log('fail');
        } else if (get(data, 'data.jwt', false)) {
          dispatch(
            openSnackBar({ message: data.message, severity: 'success' })
          );
          dispatch(disableLoader());
          if (loginType === 'student' && !studentId) {
            dashboardApi(get(data, 'data.jwt', false), dispatch);
          }
          onSignAnalytics(data.data.profile);
          dispatch(onLoginProfileData(data));
          dispatch(disableLoader());
          return dispatch(onLoginResponse(data));
        }
        dispatch(
          openSnackBar({
            message: 'Kindly enter Correct Application Form No and Password',
            severity: 'error'
          }),
          dispatch(disableLoader())
        );
        return data;
      });
  } catch (err) {
    dispatch(
      openSnackBar({
        message: 'Something went wrong, please check internet connection.',
        severity: 'error'
      })
    );
    dispatch(disableLoader());
    return console.log('fail catch');
  }
};

export const authenticateUserUsingToken = async (
  jwt,
  deviceToken,
  dispatch
) => {
  dispatch(enableLoader());
  try {
    let url = 'oauth2/astoken';

    let body = {
      JWT: jwt,
      Devicetoken: deviceToken,
      DeviceType: 'Web',
    };

    return await fetchPost(url, body)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (!data.error) {
          if (get(data, 'data.jwt', false)) {
            dispatch(
              openSnackBar({ message: data.message, severity: 'success' })
            );
            dispatch(disableLoader());
            dashboardApi(get(data, 'data.jwt', false), dispatch);
            onSignAnalytics(data.data.profile);
            dispatch(onLoginProfileData(data));
            dispatch(disableLoader());
            return dispatch(onLoginResponse(data));
          }
        }
        dispatch(
          openSnackBar({
            message: 'Kindly enter your Application Form No and Password',
            severity: 'error',
          }),
          dispatch(disableLoader())
        );
        return data;
      });
  } catch (err) {
    dispatch(
      openSnackBar({
        message: 'Something went wrong, please check internet connection.',
        severity: 'error',
      })
    );
    dispatch(disableLoader());
    return console.log('fail catch');
  }
};

export const logoutUser = async (token, dispatch) => {
  try {
    if (!token) {
      return Promise.reject();
    }
    let url = 'oauth2/logout';

    let body = {};

    await fetchPost(url, body, token)
      .then(res => {
        return res.json();
      })
      .then(() => {
        return dispatch(logOut());
      });
  } catch (err) {
    console.log('Logout Fail - ', err);
    return dispatch(disableLoader());
  }
};

export const changeAcademicSession = async (id, token, dispatch) => {
  try {
    if (!token) {
      return Promise.reject();
    }
    let url = 'api/ASChangeSession';

    let body = { SessionID: id };

    await fetchPost(url, body, token)
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (data.error && !Object.keys(data).includes('data')) {
          return dispatch(
            openSnackBar({ message: 'Some error occurred', severity: 'error' })
          );
        }
        if (!get(data, 'IsLoggedIn', true)) {
          dispatch(
            openSnackBar({
              message:
                'Multiple logins detected, please login again to continue',
              severity: 'warning'
            })
          );
          return dispatch(logOut());
        }
        return dispatch(changeAcademicSessionData(data));
      });
  } catch (err) {
    console.log('Error occurred while changing academic session');
  }
};

export const createPasswordForUser = async (
  uid,
  mobileNo,
  userName,
  email,
  dispatch
) => {
  try {
    dispatch(enableLoader());
    if (!uid || !mobileNo || !userName || !email) {
      dispatch(
        openSnackBar({
          message: 'Please fill all the details.',
          severity: 'error'
        }),
        dispatch(disableLoader())
      );
      return Promise.reject();
    }

    let url = 'api/studentgeneratepassword';

    let body = {
      AppFormNo: uid,
      FirstName: userName,
      MobileNo: mobileNo,
      EmailID: email
    };

    await fetchPost(url, body)
      .then(res => {
        return res.json();
      })
      .then(data => {
        let isSwipe = true;
        if (data.error) {
          isSwipe = false;
          // dispatch(
          //   openSnackBar({
          //     message: data.message,
          //     severity: 'error'
          //   })
          // );
        }
        dispatch(disableLoader());
        data['isSwipe'] = isSwipe;
        return dispatch(generatePasswordSwipe(data));
      });
  } catch (err) {
    console.log('Creating password Failed - ', err);
    return dispatch(disableLoader());
  }
};

export const forgetPasswordForUser = async (uid, userName, dispatch) => {
  try {
    dispatch(enableLoader());
    if (!uid || !userName) {
      dispatch(
        openSnackBar({
          message: 'Please fill all the details.',
          severity: 'error'
        }),
        dispatch(disableLoader())
      );
      return Promise.reject();
    }

    let url = 'api/studentforgetpassword';

    let body = {
      AppFormNo: uid,
      FirstName: userName
    };

    await fetchPost(url, body)
      .then(res => {
        return res.json();
      })
      .then(data => {
        let isSwipe = true;
        if (data.error) {
          isSwipe = false;
          // dispatch(
          //   openSnackBar({
          //     message: data.message,
          //     severity: 'error'
          //   })
          // );
        }
        dispatch(disableLoader());
        data['isSwipe'] = isSwipe;
        return dispatch(forgetPasswordSwipe(data));
      });
  } catch (err) {
    console.log('Creating password Failed - ', err);
    return dispatch(disableLoader());
  }
};
